import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Grid2 as Grid, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquarePlus, faKaaba, faWeight, faDollar, faDiceOne, faDiceTwo, faDiceThree } from "@fortawesome/free-solid-svg-icons";
import { TrendingUp } from "@mui/icons-material";



const IntroContent03 = ({expanded, handleChange}) => {
    const { t } = useTranslation();
    const iconType = <FontAwesomeIcon icon={faSquarePlus} size="lg" style={{ fontSize: "40px", paddingRight: '10px', paddingLeft: '10px' }} />;

    return (
        <Container className="info-container" slotProps={{ transition: { unmountOnExit: true } }}>
            <Accordion key='panel_info_1_3' id='panel_info_1_3' sx={{ width: '100%', padding: "0px 0px 0px 0px", margin: "0px 0px 0px 0px" }} expanded={expanded === 'panel_info_1_3'} onChange={handleChange('panel_info_1_3')}>
                <AccordionSummary className="info-header" expandIcon={iconType} sx={{ p: 0, m: 0 }} aria-controls="panel-info-1-3-content" id="panel-info-1-3-header">
                    <Container sx={{ padding: "0px 0px 0px 0px", margin: "0px 0px 0px 0px" }}>
                        <Box>
                            <Box component='div' className="info-header-section3" sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' } }} />
                            <h1 className="info-header-title">
                                {t('bwob.task1.section3.title')} ｜ {t('bwob.task1.section3.item')}
                            </h1>
                            <p className="info-header-descript">
                                “{t('bwob.task1.section3.description')}”
                            </p>
                        </Box>
                    </Container>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, m: 0 }}>
                    <Container className="info-content">
                        <div className="info-highlight">
                            <strong><FontAwesomeIcon icon={faKaaba} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.task1.section3.subject1')}</strong><br />
                        </div>
                        

                        <Grid container alignItems="center" spacing={1} className="info-stats" sx={{ padding: "0px 20px" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, }} sx={{ padding: "10px 20px" }}>
                                <div  className="info-statbox coffee-busan-background00">
                                    <Box component='div' className="info-stat-30" sx={{ display: { xs: 'none', sm: 'block', md: 'block', lg: 'block', xl: 'block' } }} />
                                    <h3><FontAwesomeIcon icon={faWeight} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.words.w030')}</h3>
                                    <p>({t('bwob.words.w033')})</p>
                                    <h3 style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }} className="info-stat-30-bg">
                                        <div>
                                            15.8
                                            <br /><span style={{ fontSize: "14px"}}>(2018)</span>
                                        </div>
                                        <Typography variant="span" component="div" sx={{ margin: "5px", padding: "5px", }}>
                                            <TrendingUp size="lg" sx={{ fontWeight: "900", verticalAlign: "bottom", fontSize: "40px" }} /> 
                                        </Typography>
                                        <div>
                                            20.5
                                            <br /><span style={{ fontSize: "14px"}}>(2022)</span>
                                        </div>
                                    </h3>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, }} sx={{ padding: "10px 20px" }}>
                                <div  className="info-statbox coffee-busan-background00">
                                    <Box component='div' className="info-stat-40" sx={{ display: { xs: 'none', sm: 'block', md: 'block', lg: 'block', xl: 'block' } }} />
                                    <h3><FontAwesomeIcon icon={faDollar} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.words.w031')}</h3>
                                    <p>({t('bwob.words.w034')})</p>
                                    <h3 style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }} className="info-stat-40-bg">
                                        <div>
                                            63.7
                                            <br /><span style={{ fontSize: "14px"}}>(2018)</span>
                                        </div>
                                        <Typography variant="span" component="div" sx={{ margin: "5px", padding: "5px", }}>
                                            <TrendingUp size="lg" sx={{ fontWeight: "900", verticalAlign: "bottom", fontSize: "40px", }} /> 
                                        </Typography>
                                        <div>
                                            130.4
                                            <br /><span style={{ fontSize: "14px"}}>(2022)</span>
                                        </div>
                                    </h3>
                                </div>
                            </Grid>
                        </Grid>

                        <div className="info-highlight">
                            <strong><FontAwesomeIcon icon={faKaaba} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.task1.section3.subject2')}</strong><br />
                        </div>

                        <Grid container alignItems="center" spacing={0.5} columns={12} sx={{ padding: "0px 20px" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 4, }} sx={{ padding: "0px 4px", '@media (min-width: 1200px)': { minHeight: '100px', }, '@media (min-width: 800px)': { minHeight: '90px', }, '@media (min-width: 600px)': { minHeight: '80px', }, }}>
                                <div className="info-item-highlight coffee-busan-item00">
                                    <strong><FontAwesomeIcon icon={faDiceOne} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.words.w062')}</strong><br />
                                    {t('bwob.words.w066')}<br />
                                    {t('bwob.words.w067')}
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 4, }} sx={{ padding: "0px 4px", minHeight: "100px" }}>
                                <div className="info-item-highlight coffee-busan-item00">
                                    <strong><FontAwesomeIcon icon={faDiceTwo} size="lg" style={{ paddingRight: '10px' }}/> {t('bwob.words.w063')}<br />{t('bwob.words.w027')} {t('bwob.words.w065')}</strong><br />
                                    2022,<br />
                                    {t('bwob.words.w068')}
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 4, }} sx={{ padding: "0px 4px", minHeight: "100px" }}>
                                <div className="info-item-highlight coffee-busan-item00">
                                    <strong><FontAwesomeIcon icon={faDiceThree} size="lg" style={{ paddingRight: '10px' }}/> BUSAN COFFEE DATA HUB</strong><br />
                                    <strong>{t('bwob.words.w064')}</strong><br />
                                    <strong>{t('bwob.words.w069')}</strong>
                                </div>
                            </Grid>
                        </Grid>

                        <div style={{ display: 'block', width: '100%', margin: '5px', padding: '3px'}}></div>

                    </Container>
                </AccordionDetails>
            </Accordion>

        </Container>
    );
};

IntroContent03.propTypes = {
    expanded: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default IntroContent03;